/**
 * ImageBlock Component
 */
import React from "react";
import { filterClass } from "../../utils/class-utils";
import { getBlockAlignClass, resolveHorizontalContentAlign } from "../utils/content-alignment";
import type { ImageBlockProps } from "../types";

function stripCardImageUtilityClasses(className?: string) {
  if (!className) return className;

  return className
    .split(/\s+/)
    .filter(Boolean)
    .filter((token) => !/^border(?:-.+)?$/.test(token))
    .filter((token) => !/^rounded(?:-.+)?$/.test(token))
    .filter((token) => !/^(mx|ms|me)-auto$/.test(token))
    .join(" ");
}

export function ImageBlock(props: ImageBlockProps) {
  const {
    src,
    alt,
    paddingClass = "no-class",
    horizontalAlignClass,
    inheritedContentAlign,
    border,
    borderWidth,
    borderColorClass = "no-class",
    borderRadius,
    className,
    disableCardImageStyling = false,
  } = props;

  const resolvedPaddingClass = disableCardImageStyling ? "no-class" : paddingClass;
  const resolvedBorderWidth = disableCardImageStyling ? undefined : borderWidth;
  const resolvedBorderColorClass = disableCardImageStyling ? "no-class" : borderColorClass;
  const resolvedBorderRadius = disableCardImageStyling ? "none" : borderRadius;
  const resolvedClassName = disableCardImageStyling ? stripCardImageUtilityClasses(className) : className;

  const borderWidthClass = resolvedBorderWidth ? `border-${resolvedBorderWidth}` : "";
  const borderClass = (!disableCardImageStyling && (border || borderWidthClass || filterClass(resolvedBorderColorClass))) ? "border" : "";

  const borderRadiusClass =
    resolvedBorderRadius === "none"
      ? "rounded-0"
      : resolvedBorderRadius === "sm"
        ? "rounded-1"
        : resolvedBorderRadius === "md"
          ? "rounded-2"
          : resolvedBorderRadius === "lg"
            ? "rounded-3"
            : resolvedBorderRadius === "pill"
              ? "rounded-pill"
              : resolvedBorderRadius === "circle"
                ? "rounded-circle"
                : "";

  const resolvedHorizontalAlignClass = disableCardImageStyling
    ? ""
    : getBlockAlignClass(
      resolveHorizontalContentAlign(horizontalAlignClass, inheritedContentAlign, "center")
    );

  const imgClassName = [
    "d-block",
    "img-fluid",
    resolvedHorizontalAlignClass,
    borderClass,
    borderWidthClass,
    filterClass(resolvedBorderColorClass),
    borderRadiusClass,
    resolvedClassName,
  ]
    .filter(Boolean)
    .join(" ");

  const containerClassName = [
    "w-100",
    filterClass(resolvedPaddingClass),
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClassName}>
      <img
        src={src || "https://placehold.co/400x400"}
        alt={alt || "Image"}
        className={imgClassName}
      />
    </div>
  );
}

export default ImageBlock;

